import { AlignCenterHorizontalIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const AlignCenter = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <AlignCenterHorizontalIcon size={Sizes[size]} {...rest} color={fill} />;
};

AlignCenter.displayName = 'AlignCenter';
